import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ocean',
  templateUrl: './ocean.component.html',
  styleUrls: ['./ocean.component.scss']
})
export class OceanComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
